import dayjs from 'dayjs';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

//transforms an array of objects into a key-value object
//based on specified key and value properties
export const arrayToKeyValue = (array, key, value) => {
  if (!array) return {};
  return array.reduce((acc, obj) => {
    acc[obj[key]] = obj[value];
    return acc;
  }, {});
};

export const formatAccessStats = (accessStats, selectedDate) => {
  if (!accessStats) return;

  //reduce array of objects to a single object
  const formattedAccessStats = arrayToKeyValue(
    accessStats,
    'date',
    'totalCount'
  );

  //create an object with all days of a month and assign a value of 0
  const allDatesOfMonth = {};
  for (let i = 0; i < dayjs(selectedDate, 'DD-MM-YYYY').daysInMonth(); i++) {
    allDatesOfMonth[
      `${dayjs(selectedDate, 'DD-MM-YYYY')
        .startOf('month')
        .add(i, 'day')
        .format('YYYY-MM-DD')}`
    ] = '0';
  }

  //merge with the ones already present in the access stats list
  for (const key in allDatesOfMonth) {
    if (formattedAccessStats.hasOwnProperty(key)) {
      allDatesOfMonth[key] = formattedAccessStats[key];
    }
  }

  //rename the keys to the day number only (for data visualization)
  let count = 1;
  for (const key in allDatesOfMonth) {
    if (allDatesOfMonth.hasOwnProperty(key)) {
      allDatesOfMonth[count] = allDatesOfMonth[key];
      delete allDatesOfMonth[key];
      count += 1;
    }
  }

  return allDatesOfMonth;
};

export const ACCESS_STATS_CHART_OPTS = {
  scales: {
    x: {
      ticks: {
        maxTicksLimit: 0, //no vertical grid lines
        autoSkip: false, //don't skip labels
        maxRotation: 0, //don't rotate labels
        //show only labels multiples of 10
        callback(value) {
          return value === 0 ? '' : value % 10 === 0 ? value : '';
        },
      },
    },
    y: {
      ticks: {
        maxTicksLimit: 7, //max horizontal grid lines
      },
    },
  },
};

export const COURSE_STATS_CHART_OPTS = {
  scales: {
    x: {
      ticks: {
        maxTicksLimit: 0, //no vertical grid lines
        autoSkip: false, //don't skip labels
      },
    },
    y: {
      ticks: {
        maxTicksLimit: 4, //max horizontal grid lines
        //show only integers
        callback(value) {
          return value % 1 === 0 ? value : '';
        },
      },
    },
  },
};

export const ACTIVITY_STATS_CHART_OPTS = {
  scales: {
    x: {
      ticks: {
        maxTicksLimit: 0, //no vertical grid lines
        autoSkip: false, //don't skip labels
        //truncate labels with ellipsis
        callback(value) {
          // eslint-disable-next-line react/no-this-in-sfc
          const label = this.getLabelForValue(value);
          const desiredLength = 16;
          if (typeof label === 'string' && label.length > desiredLength) {
            return `${label.substring(0, desiredLength)}...`;
          }
          return label;
        },
      },
    },
    y: {
      ticks: {
        maxTicksLimit: 4, //max horizontal grid lines
        //show only integers
        callback(value) {
          return value % 1 === 0 ? value : '';
        },
      },
    },
  },
};

export const REGION_PROVINCE_CHART_OPTS = {
  maintainAspectRatio: false,
  scales: {
    x: {
      ticks: {
        maxTicksLimit: 0, //no vertical grid lines
        autoSkip: false, //don't skip labels
      },
    },
    y: {
      ticks: {
        maxTicksLimit: 3, //max horizontal grid lines
      },
    },
  },
};

export function formatNumberToK(number) {
  if (!number) return;
  if (number >= 1000) return `${(number / 1000).toFixed(0)}K`;
  return number;
}
